export enum KeybeSelectTypeEnum {
  TEXT_VALUE = 'text_value',
  TEXT_OBJECT = 'text_object',
  NONE = 'none',
  STATUS = 'status',
  PHONE_NUMBERS = 'phone_numbers',
  MULTIPLE = 'multiple'
}
